var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["name", "type", "validateTrigger", "rules", "initialValue", "getValueFromEvent", "rows", "customData"], _excluded2 = ["validateTrigger", "rules", "options", "initialValue", "initialSelectedIndex"], _excluded3 = ["customRenderer"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import { FormInput } from "../elements/Input";
import { FormTextarea } from "../elements/Textarea";
import { FormSelect, FormSelectOption } from "../elements/Select";
import { FormInputPhone } from "../elements/phone/Input";
import { FormInputDatePicker } from "../elements/date/Picker";
import { SubscribeSection } from "../sections/Subscribe";
var buildCustomInputProps = /* @__PURE__ */ __name(function buildCustomInputProps2(settings, props) {
  var builtProps = {};
  if (settings.prefix) {
    builtProps.prefix = typeof settings.prefix === "function" ? settings.prefix(props) : settings.prefix;
  }
  if (settings.suffix) {
    builtProps.suffix = typeof settings.suffix === "function" ? settings.suffix(props) : settings.suffix;
  }
  return builtProps;
}, "buildCustomInputProps");
var renderTextElements = /* @__PURE__ */ __name(function renderTextElements2(InputComponent, rows) {
  return (
    // eslint-disable-next-line react/function-component-definition
    function(props, _ref) {
      var name = _ref.name, type = _ref.type, validateTrigger = _ref.validateTrigger, rules = _ref.rules, initialValue = _ref.initialValue, getValueFromEvent = _ref.getValueFromEvent, fieldSetRows = _ref.rows, customData = _ref.customData, restProps = _objectWithoutProperties(_ref, _excluded);
      return /* @__PURE__ */ React.createElement(InputComponent, _extends({
        type,
        name
      }, restProps, rows || fieldSetRows ? {
        rows: fieldSetRows || rows
      } : null, buildCustomInputProps(_objectSpread({
        customData
      }, restProps), props)));
    }
  );
}, "renderTextElements");
var renderPhone = /* @__PURE__ */ __name(function renderPhone2(props, inputProps) {
  return /* @__PURE__ */ React.createElement(FormInputPhone, _extends({}, inputProps, {
    builderProps: props
  }));
}, "renderPhone");
var renderDatePicker = /* @__PURE__ */ __name(function renderDatePicker2(props, inputProps) {
  return /* @__PURE__ */ React.createElement(FormInputDatePicker, _extends({}, inputProps, {
    builderProps: props
  }));
}, "renderDatePicker");
var renderSelect = /* @__PURE__ */ __name(function renderSelect2(props, _ref2) {
  var validateTrigger = _ref2.validateTrigger, rules = _ref2.rules, options = _ref2.options, initialValue = _ref2.initialValue, initialSelectedIndex = _ref2.initialSelectedIndex, restProps = _objectWithoutProperties(_ref2, _excluded2);
  return /* @__PURE__ */ React.createElement(FormSelect, _extends({
    size: "large",
    choiceTransitionName: null,
    transitionName: null,
    getPopupContainer: /* @__PURE__ */ __name(function getPopupContainer(triggerNode) {
      return triggerNode.parentElement;
    }, "getPopupContainer")
  }, buildCustomInputProps(restProps, props)), options(props.intl).map(function(_ref3) {
    var value = _ref3.value, text = _ref3.text;
    return /* @__PURE__ */ React.createElement(FormSelectOption, {
      key: value,
      value
    }, text);
  }));
}, "renderSelect");
var renderSubscribe = /* @__PURE__ */ __name(function renderSubscribe2(_ref4) {
  var intl = _ref4.intl;
  return SubscribeSection({
    intl
  });
}, "renderSubscribe");
var customFieldRenderer = /* @__PURE__ */ __name(function customFieldRenderer2(_ref5, inputProps) {
  var customRenderer = _ref5.customRenderer, restProps = _objectWithoutProperties(_ref5, _excluded3);
  return customRenderer(restProps, inputProps);
}, "customFieldRenderer");
var tagToRenderer = {
  input: renderTextElements(FormInput),
  phone: renderPhone,
  datePicker: renderDatePicker,
  textarea: renderTextElements(FormTextarea, 4),
  select: renderSelect,
  customRenderer: customFieldRenderer,
  subscribeSection: renderSubscribe
};
export {
  tagToRenderer
};
